import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xvvfvktx6s: FaireBrandEntity = {
  token: "b_xvvfvktx6s",
  type: "brand",
  name: "Rylee Faith Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/a7834e6bbe07f3b7798d15c679f683f4e3805963309d360fd3e2186c10676e64.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7f00f7d97767fe68a91990e30cd7c7fc7ce167a9cdec96a0ac0864892c9ffb47.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a7834e6bbe07f3b7798d15c679f683f4e3805963309d360fd3e2186c10676e64.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7f00f7d97767fe68a91990e30cd7c7fc7ce167a9cdec96a0ac0864892c9ffb47.jpeg",
  location: "LAKE FOREST, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 544,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Rylee Faith Designs ! We are excited to offer you quality girl's boutique clothing & items at affordable prices with FAST shipping! We have an expanding collection of girl's boutique clothing, toddler girl's boutique items, bows, accessories, bags & more! We strive for EXCELLENT customer service & offer a satisfaction guarantee! As a Christian based company, we take pride in what we do to honor Him. \n\nRylee Faith Designs Boutique is built around style and beauty.  We want to celebrate and empower an inclusive community where every little girl and mama can have the confidence to be everything she wants to be. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:43.658Z",
    importedBy: "entity-db-cli",
  },
};
